/**
 * Drizzle query builders + query-key factory de los MODELOS DE CALIFICACIÓN
 * (grupo E). Consumo local-first sobre PowerSync (stream `academy_org`): los
 * miembros de la org LEEN los modelos para renderizar notas y elegir escala. La
 * ESCRITURA es por REST (`/api/academy/:orgId/grading-models`), no local-first.
 */

import {
  and,
  asc,
  desc,
  eq,
  grading_model,
  isNull,
  type PowerSyncDrizzleDB,
} from "@space/powersync";

export const gradingModelsQueryKeys = {
  all: ["academy-grading-models"] as const,
  byOrg: (orgId: string | undefined) => ["academy-grading-models", orgId] as const,
};

/** Modelos vivos de una org, con los del sistema primero y luego por nombre. */
export function getGradingModelsQuery(db: PowerSyncDrizzleDB, orgId: string) {
  return db
    .select()
    .from(grading_model)
    .where(and(eq(grading_model.organization_id, orgId), isNull(grading_model.deleted_at)))
    .orderBy(desc(grading_model.is_system), asc(grading_model.name));
}

/** Un modelo por id (para resolver la selección de un curso/cohorte). */
export function getGradingModelByIdQuery(db: PowerSyncDrizzleDB, modelId: string) {
  return db.select().from(grading_model).where(eq(grading_model.id, modelId)).limit(1);
}
